import m from 'mithril'
import Router from '@shared/components/router'

export const MODES = {
	SIGOPS: "sigops",
	SAFETY: "safety",
	MOBILITY: "mobility",
	ORIGIN_DESTINATION: "origin_destination",
};

export const ALL_AVAILABLE_MODES_BY_ENTITY = {
	region: [MODES.SIGOPS, /*MODES.SAFETY,*/ MODES.MOBILITY, MODES.ORIGIN_DESTINATION],
	subregion: [MODES.SIGOPS, /*MODES.SAFETY,*/ MODES.MOBILITY, MODES.ORIGIN_DESTINATION],
	network: [MODES.SIGOPS, /*MODES.SAFETY,*/ MODES.MOBILITY, MODES.ORIGIN_DESTINATION],
	network_ad_hoc: [MODES.SIGOPS, /*MODES.SAFETY, MODES.MOBILITY*/],
	intersection: [/*MODES.SIGOPS,*/ MODES.SAFETY, /*MODES.MOBILITY*/],
	signal: [MODES.SIGOPS, /*MODES.SAFETY, MODES.MOBILITY*/],
	signal_ad_hoc: [MODES.SIGOPS, /*MODES.SAFETY, MODES.MOBILITY*/],
	roadway: [/*MODES.SIGOPS, MODES.SAFETY,*/ MODES.MOBILITY],
	roadway_ad_hoc: [MODES.SIGOPS, MODES.MOBILITY, /* MODES.SAFETY*/],
}


export const routes = {

	root: {
		path: "/",
		title: "Home | Flow Labs",
	},
	// ONE-OFF: legacy Optimus config migration tool
	optimus_migrate: {
		path: "/optimus-migrate",
		title: "Optimus Migrate | Flow Labs",
	},
	system: {
		path: "/map/:customer_id",
		title: "System | Flow Labs",
		defaults: {
			query: {
				mode: MODES.SIGOPS,
				active_sidebar: "right",
				sidebar_c_tab: "networks",
				hmm: "control-delay",
				selected_metric: "control-delay",
				selected_tab: "sigops",
			},
		},
	},

	// Signal Operations Mode
	sigops_region: {
		path: "/map/:customer_id/region/:region_id/sigops",
		title: "Signal Operations | Region | :region_id | Flow Labs",
		defaults: {
			query: {
				mode: MODES.SIGOPS,
				active_sidebar: "right",
				sidebar_c_tab: "networks",
				hmm: "control-delay",
				selected_metric: "control-delay",
				selected_tab: "sigops",
				hcs: "ryg",
				scs: "none",
				rtf: "11111111",
				etf: "111111",
			},
		},
	},
	sigops_subregion: {
		path: "/map/:customer_id/region/:region_id/subregion/:subregion_id/sigops",
		title: "Signal Operations | Subregion | :subregion_id | Flow Labs",
		defaults: {
			query: {
				mode: MODES.SIGOPS,
				active_sidebar: "right",
				sidebar_c_tab: "networks",
				hmm: "control-delay",
				selected_metric: "control-delay",
				selected_tab: "sigops",
				hcs: "ryg",
				scs: "none",
				rtf: "11111111",
				etf: "111111",
			},
		},
	},
	sigops_network: {
		path: "/map/:customer_id/region/:region_id/network/:network_id/sigops",
		title: "Signal Operations | Network | :network_id | Flow Labs",
		defaults: {
			query: {
				mode: MODES.SIGOPS,
				active_sidebar: "right",
				hmm: "control-delay",
				selected_metric: "control-delay",
				selected_tab: "sigops",
				hcs: "ryg",
				scs: "none",
				rtf: "11111111",
				etf: "111111",
			},
		},
	},
	sigops_network_ad_hoc: {
		path: "/map/:customer_id/region/:region_id/network/:network_id/sigops/custom",
		title: "Signal Operations | Network | :network_id | Custom | Flow Labs",
		defaults: {
			query: {
				mode: MODES.SIGOPS,
				active_sidebar: "right",
				hmm: "control-delay",
				selected_metric: "control-delay",
				selected_tab: "sigops",
				hcs: "ryg",
				scs: "none",
				rtf: "11111111",
				etf: "111111",
			},
		},
	},
	sigops_signal: {
		path: "/map/:customer_id/region/:region_id/network/:network_id/signal/:signal_id/sigops",
		title: "Signal Operations | Signal | :signal_id | Flow Labs",
		defaults: {
			query: {
				mode: MODES.SIGOPS,
				active_sidebar: "right",
				hmm: "control-delay",
				selected_metric: "control-delay",
				selected_tab: "sigops",
				hcs: "ryg",
				scs: "none",
				rtf: "11111111",
				etf: "111111",
			},
		},
	},
	sigops_signal_ad_hoc: {
		path: "/map/:customer_id/region/:region_id/network/:network_id/signal/:signal_id/sigops/custom",
		title: "Signal Operations | Signal | :signal_id | Custom | Flow Labs",
		defaults: {
			query: {
				mode: MODES.SIGOPS,
				active_sidebar: "right",
				hmm: "control-delay",
				selected_metric: "control-delay",
				selected_tab: "sigops",
				hcs: "ryg",
				scs: "none",
				rtf: "11111111",
				etf: "111111",
			},
		},
	},
	sigops_intersection: {
		path: "/map/:customer_id/region/:region_id/network/:network_id/signal/:signal_id/intersection/:intersection_id/sigops",
		title: "Signal Operations | Intersection | :intersection_id | Flow Labs",
		defaults: {
			query: {
				mode: MODES.SIGOPS,
				active_sidebar: "right",
				hmm: "control-delay",
				selected_metric: "control-delay",
				selected_tab: "sigops",
				hcs: "ryg",
				scs: "none",
				rtf: "11111111",
				etf: "111111",
			},
		},
	},
	sigops_intersection_phase: {
		path: "/map/:customer_id/region/:region_id/network/:network_id/signal/:signal_id/intersection/:intersection_id/phase/:phase_id/sigops",
		title: "Signal Operations | Phase | :phase_id | Flow Labs",
		defaults: {
			query: {
				mode: MODES.SIGOPS,
				active_sidebar: "right",
				hmm: "control-delay",
				selected_metric: "control-delay",
				selected_tab: "sigops",
				hcs: "ryg",
				scs: "none",
				rtf: "11111111",
				etf: "111111",
			},
		},
	},
	sigops_phase: {
		path: "/map/:customer_id/region/:region_id/network/:network_id/signal/:signal_id/phase/:phase_id/sigops",
		title: "Signal Operations | Phase | :phase_id | Flow Labs",
		defaults: {
			query: {
				mode: MODES.SIGOPS,
				active_sidebar: "right",
				hmm: "control-delay",
				selected_metric: "control-delay",
				selected_tab: "sigops",
				hcs: "ryg",
				scs: "none",
				rtf: "11111111",
				etf: "111111",
			},
		},
	},
	sigops_phase_ad_hoc: {
		path: "/map/:customer_id/region/:region_id/network/:network_id/signal/:signal_id/phase/:phase_id/sigops/custom",
		title: "Signal Operations | Phase | :phase_id | Custom | Flow Labs",
		defaults: {
			query: {
				mode: MODES.SIGOPS,
				active_sidebar: "right",
				hmm: "control-delay",
				selected_metric: "control-delay",
				selected_tab: "sigops",
				hcs: "ryg",
				scs: "none",
				rtf: "11111111",
				etf: "111111",
			},
		},
	},

	// Safety Mode
	safety_region: {
		path: "/map/:customer_id/region/:region_id/safety",
		title: "Safety | Region | :region_id | Flow Labs",
		defaults: {
			query: {
				mode: MODES.SAFETY,
				active_sidebar: "right",
				sidebar_c_tab: "edge-groups",
				sidebar_c_page: "0",
				// hmm: 'crashes',
				hcs: "g2r",
				scs: "none",
				rtf: "11111111",
				etf: "110000",
			},
		},
	},
	safety_subregion: {
		path: "/map/:customer_id/region/:region_id/subregion/:subregion_id/safety",
		title: "Safety | Subregion | :subregion_id | Flow Labs",
		defaults: {
			query: {
				mode: MODES.SAFETY,
				active_sidebar: "right",
				sidebar_c_tab: "edge-groups",
				sidebar_c_page: "0",
				// hmm: 'crashes',
				hcs: "g2r",
				scs: "none",
				rtf: "11111111",
				etf: "110000",
			},
		},
	},
	safety_network: {
		path: "/map/:customer_id/region/:region_id/network/:network_id/safety",
		title: "Safety | Network | :network_id | Flow Labs",
		defaults: {
			query: {
				mode: MODES.SAFETY,
				active_sidebar: "right",
				sidebar_c_tab: "edge-groups",
				sidebar_c_page: "0",
				// hmm: 'crashes',
				hcs: "g2r",
				scs: "none",
				rtf: "11111111",
				etf: "110000",
			},
		},
	},
	safety_signal: {
		path: "/map/:customer_id/region/:region_id/network/:network_id/signal/:signal_id/safety",
		title: "Safety | Signal | :signal_id | Flow Labs",
		defaults: {
			query: {
				mode: MODES.SAFETY,
				active_sidebar: "right",
				sidebar_c_tab: "edge-groups",
				sidebar_c_page: "0",
				// hmm: 'crashes',
				hcs: "g2r",
				scs: "none",
				rtf: "11111111",
				etf: "110000",
			},
		},
	},
	safety_phase: {
		path: "/map/:customer_id/region/:region_id/network/:network_id/signal/:signal_id/phase/:phase_id/safety",
		title: "Safety | Phase | :phase_id | Flow Labs",
		defaults: {
			query: {
				mode: MODES.SAFETY,
				active_sidebar: "right",
				sidebar_c_tab: "edge-groups",
				sidebar_c_page: "0",
				// hmm: 'crashes',
				hcs: "g2r",
				scs: "none",
				rtf: "11111111",
				etf: "110000",
			},
		},
	},
	safety_intersection: {
		path: "/map/:customer_id/region/:region_id/network/:network_id/intersection/:intersection_id/safety",
		title: "Safety | Intersection | :intersection_id | Flow Labs",
		defaults: {
			query: {
				mode: MODES.SAFETY,
				active_sidebar: "right",
				sidebar_c_tab: "edge-groups",
				sidebar_c_page: "0",
				// hmm: 'crashes',
				hcs: "g2r",
				scs: "none",
				rtf: "11111111",
				etf: "110000",
			},
		},
	},

	// Mobility Mode
	mobility_region: {
		path: "/map/:customer_id/region/:region_id/mobility",
		title: "Mobility | Region | :region_id | Flow Labs",
		defaults: {
			query: {
				mode: MODES.MOBILITY,
				active_sidebar: "right",
				sidebar_c_tab: "edge-groups",
				sidebar_c_page: "0",
				hmm: "mobility",
				hcs: "ryg",
				scs: "none",
				rtf: "11111111",
				etf: "111111",
			},
		},
	},
	mobility_subregion: {
		path: "/map/:customer_id/region/:region_id/subregion/:subregion_id/mobility",
		title: "Mobility | Subregion | :subregion_id | Flow Labs",
		defaults: {
			query: {
				mode: MODES.MOBILITY,
				active_sidebar: "right",
				sidebar_c_tab: "edge-groups",
				sidebar_c_page: "0",
				hmm: "mobility",
				hcs: "ryg",
				scs: "none",
				rtf: "11111111",
				etf: "111111",
			},
		},
	},
	mobility_network: {
		path: "/map/:customer_id/region/:region_id/network/:network_id/mobility",
		title: "Mobility | Network | :network_id | Flow Labs",
		defaults: {
			query: {
				mode: MODES.MOBILITY,
				active_sidebar: "right",
				sidebar_c_tab: "edge-groups",
				sidebar_c_page: "0",
				hmm: "mobility",
				hcs: "ryg",
				scs: "none",
				rtf: "11111111",
				etf: "111111",
			},
		},
	},
	// Ad Hoc route must be before base route to avoid short-circuit
	roadway_ad_hoc: {
		path: "/map/customer/:customer_id/region/:region_id?/subregion/:subregion_id?/network/:network_id?/roadway/custom/edge/:edge_id?",
		/*
			TODO
			Update title when moving between
				- Safety<->Mobility
				- EdgeGroups<->Edges
				- different kinds of EdgeGroups (Workzones, Roadways, Routes)
		*/
		title: "Roadway | Custom | Flow Labs",
		defaults: {
			query: {
				active_sidebar: "right",
				sidebar_c_tab: "edge-groups",
				sidebar_c_page: "0",
				hmm: "mobility",
				hcs: "ryg",
				scs: "none",
				rtf: "11111111",
				etf: "111111",
				mode: "mobility",
			},
		},
	},
	roadway_edit: {
		path: "/map/customer/:customer_id/region/:region_id?/subregion/:subregion_id?/network/:network_id?/roadway/:roadway_id/edit",
		title: "Edit | Roadway | :roadway_id | Flow Labs",
		defaults: {
			query: {
				active_sidebar: "right",
				sidebar_c_tab: "edge-groups",
				sidebar_c_page: "0",
				hmm: "mobility",
				hcs: "ryg",
				scs: "none",
				rtf: "11111111",
				etf: "111111",
				mode: "mobility",
			},
		},
	},
	roadway: {
		path: "/map/customer/:customer_id/region/:region_id?/subregion/:subregion_id?/network/:network_id?/roadway/:roadway_id/edge/:edge_id?",
		/*
			TODO
			Update title when moving between
				- Safety<->Mobility
				- EdgeGroups<->Edges
				- different kinds of EdgeGroups (Workzones, Roadways, Routes)
		*/
		title: "Roadway | :roadway_id | Flow Labs",
		defaults: {
			query: {
				active_sidebar: "right",
				sidebar_c_tab: "edge-groups",
				sidebar_c_page: "0",
				hmm: "mobility",
				hcs: "ryg",
				scs: "none",
				rtf: "11111111",
				etf: "111111",
				mode: "mobility",
			},
		},
	},

	network_edit: {
		path: "/map/:customer_id/region/:region_id/network/:network_id/edit",
		title: "Edit | Network | :network_id | Flow Labs",
		defaults: {
			query: {
				mode: MODES.SIGOPS,
				active_sidebar: "right",
				hmm: "mobility",
				hcs: "ryg",
				scs: "none",
				rtf: "11111111",
				etf: "111111",
			},
		},
	},

	merge_networks: {
		path: "/map/:customer_id/region/:region_id/merge-networks",
		title: "Merge Networks | Region | :region_id | Flow Labs",
		defaults: {
			query: {
				mode: MODES.SIGOPS,
				active_sidebar: "right",
				hmm: "mobility",
				hcs: "ryg",
				scs: "none",
				rtf: "11111111",
				etf: "111111",
			},
		},
	},

	/**
	 * Origin-Destination
	 */
	origin_destination: {
		path: "/origin-destination/:customer_id/region/:region_id",
		title: "Origin-Destination | Region | :region_id | Flow Labs",
	},

	// cerberus_v2: {
	// 	path: "/cerberus-v2/:customer_id",
	// 	component: CerberusPage,
	// 	title: "Cerberus | Flow Labs",
	// },
	cerberus: {
		path: "/cerberus/:customer_id",
		title: "Cerberus | Flow Labs",
	},

	data_monitoring_redirect: {
		path: "/data-monitoring",
		component: {
			oninit: () => routes.data_monitoring_feeds.navigate(),
			view: () => m("div"),
		},
	},
	data_monitoring_feeds: {
		path: "/data-monitoring/feeds",
		title: "Data Monitoring | Feeds | Flow Labs",
	},
	data_monitoring_feeds_customer: {
		path: "/data-monitoring/feeds/customer/:customer_id",
		title: "Data Monitoring | Feeds | Flow Labs",
	},
	data_monitoring_quality: {
		path: "/data-monitoring/quality",
		title: "Data Monitoring | Quality | Flow Labs",
	},
	data_monitoring_quality_customer: {
		path: "/data-monitoring/quality/customer/:customer_id",
		title: "Data Monitoring | Quality | Flow Labs",
	},

	/**
	 * Reports
	 */
	reports: {
		path: "/reports/:customer_id",
		title: "Reports | Flow Labs",
		defaults: {
			query: {
				type: "all",
			},
		},
	},

	report_origin_destination: {
		path: "/reports/:customer_id/origin-destination/:report_id",
		title: "Reports | Origin-Destination | :report_id | Flow Labs",
	},

	//access denied page
	access_denied: {
		path: "/access-denied",
		title: "Access Denied | Flow Labs",
	},
};

// Add sandbox route only in non-production environments
// IMPORTANT: Must be added BEFORE default_redirect to prevent redirect
// Component is assigned in main.js (to avoid pulling in page imports here)
if (process.env.NODE_ENV !== "production") {
	routes.sandbox = {
		path: "/sandbox",
		title: "Sandbox | Flow Labs",
	};

	routes.sandbox_customer = {
		path: "/sandbox/:customer_id",
		title: "Sandbox | Flow Labs",
	};
}

// Must be last - catches all unmatched routes
routes.default_redirect = {
	path: "/*",
	component: { oninit: () => routes.root.navigate(), view: () => m("div") },
};

const router = new Router({ routes });

export default router
